var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    { attrs: { "border-color": "orange", "has-toggle": false } },
    [
      _c(
        "div",
        { staticClass: "py-2" },
        [
          _c(
            "div",
            { staticClass: "d-flex" },
            [
              _c("icon-view", {
                staticClass: "mt-5 mb-3 mt-md-0 mt-sm-5",
                attrs: {
                  gradient: false,
                  icon: "fas fa-sync-alt p-2",
                  "icon-background": "#ff7058",
                  "icon-color": "white",
                  "icon-size": "14px",
                  title: "Generar Catálogo"
                }
              })
            ],
            1
          ),
          _c("validation-observer", { ref: "formObserver" }, [
            _c("div", { staticClass: "row p-2" }, [
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              staticClass: "w-100",
                              attrs: {
                                "custom-error-msg":
                                  "El año académico es requerido.",
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "name",
                                label: "Año Académico:",
                                options: _vm.collections.academicYears,
                                placeholder: "Seleccione"
                              },
                              model: {
                                value: _vm.model.academicYear,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "academicYear", $$v)
                                },
                                expression: "model.academicYear"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              staticClass: "w-100",
                              attrs: {
                                "custom-error-msg": "El área es requerida.",
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "name",
                                label: "Área:",
                                options: _vm.collections.areas,
                                placeholder: "Seleccione"
                              },
                              on: { input: _vm.onAreaChange },
                              model: {
                                value: _vm.model.area,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "area", $$v)
                                },
                                expression: "model.area"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-md-4" },
                [
                  _c("validation-provider", {
                    attrs: { rules: "required" },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function({ errors }) {
                          return [
                            _c("custom-drop-down", {
                              staticClass: "w-100",
                              attrs: {
                                "custom-error-msg":
                                  "El tipo de proveedor es requerido.",
                                error: errors[0],
                                fieldkey: "id",
                                fieldname: "name",
                                label: "Tipo de Proveedor:",
                                options: _vm.providerTypes,
                                placeholder: "Seleccione"
                              },
                              model: {
                                value: _vm.model.recruitmentType,
                                callback: function($$v) {
                                  _vm.$set(_vm.model, "recruitmentType", $$v)
                                },
                                expression: "model.recruitmentType"
                              }
                            })
                          ]
                        }
                      }
                    ])
                  })
                ],
                1
              )
            ]),
            _c(
              "div",
              { staticClass: "d-flex justify-content-end mt-3" },
              [
                _c("action-button", {
                  attrs: {
                    i: "fas fa-times-circle",
                    text: "Cancelar",
                    variant: "outline-danger mr-3 pl-3 pr-4"
                  },
                  on: { click: _vm.onCancelHandler }
                }),
                _c("action-button", {
                  attrs: {
                    i: "fas fa-sync-alt",
                    text: "Generar",
                    variant: "success pl-3 pr-3"
                  },
                  on: { click: _vm.onGenerateHandler }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }